<template>
  <div>
    <SelectTeamInstruction
      name="attacking-width"
      :value="attackingWidth"
      mutation="updateAttackingWidth"
      :options="options.attackingWidth"
    >
      {{ $t('tactics.instructions.inPossession.attackingWidth.attackingWidth') }}
    </SelectTeamInstruction>
    <!--<label for="attacking-width" class="--uppercase">
      {{ $t('tactics.instructions.inPossession.attackingWidth.attackingWidth') }}
    </label>
    <select
        class="ti-select --capitalise"
        name="attacking-width"
        v-model="attackingWidth.value"
        @change="$emit('update:attacking-width', $event.target.value)"
    >
      <option 
          v-for="instruction in attackingWidth.possibleInstructions"
          :key="attackingWidth.affects + instruction.value"
          :value="instruction.value"
      >
        {{ $t(instruction.label) }}
      </option>
    </select>-->
  </div>
</template>

<script>
import { mapState } from "vuex";
import SelectTeamInstruction from "@/components/SelectTeamInstruction";

export default {
  components: {
    SelectTeamInstruction
  },

  data: function() {
    return {
      options: {
        attackingWidth: [
          { value: -2, label: 'tactics.instructions.inPossession.attackingWidth.extremelyNarrow' },
          { value: -1, label: 'tactics.instructions.inPossession.attackingWidth.narrow' },
          { value: 0, label: 'tactics.instructions.inPossession.attackingWidth.standard' },
          { value: 1, label: 'tactics.instructions.inPossession.attackingWidth.wide' },
          { value: 2, label: 'tactics.instructions.inPossession.attackingWidth.extremelyWide' }
        ]
      }/*,
      attackingWidth: {
        affects: 'attacking_width',
        value: 0,
        possession: 'inPossession',
        label: 'attacking width',
        action: '',
        possibleInstructions: [
          { value: 2, label: 'tactics.instructions.inPossession.attackingWidth.extremelyNarrow' },
          { value: 1, label: 'tactics.instructions.inPossession.attackingWidth.narrow' },
          { value: 0, label: 'tactics.instructions.inPossession.attackingWidth.standard' },
          { value: -1, label: 'tactics.instructions.inPossession.attackingWidth.wide' },
          { value: -2, label: 'tactics.instructions.inPossession.attackingWidth.extremelyWide' }
        ]
      }*/
    }
  },

  computed: mapState({
    attackingWidth: state => state.instructions.inPossession.attackingWidth.attackingWidth
  })
}
</script>

<style scoped>

</style>
